import React from 'react';
import { ControlLabel, FormControl, FormGroup, InputGroup, Form } from 'react-bootstrap';
import 'react-phone-input-2/lib/style.css';

import './Common.css';


export const PersonalInformationComponent = (props) => {
    return (
        <div className="bottomPadding">

            <ControlLabel>First Name *</ControlLabel>
            <FormControl type="text" name="firstName" id="firstName"
                value={props.firstName}
                onChange={props.handleInputChange} />

            <ControlLabel>Middle Name</ControlLabel>
            <FormControl type="text" name="middleName"
                value={props.middleName}
                onChange={props.handleInputChange} />

            <ControlLabel>Last Name *</ControlLabel>
            <FormControl type="text" name="lastName"
                value={props.lastName}
                onChange={props.handleInputChange} />

            <div className="rowC">
                <div>
                    <ControlLabel>Gender *</ControlLabel>
                    <FormControl name="gender"
                        componentClass="select"
                        value={props.gender}
                        onChange={props.handleInputChange}>
                        <option></option>
                        <option value="F">Female</option>
                        <option value="M">Male</option>
                    </FormControl>
                </div>
                <div>
                    <ControlLabel>Date Of Birth *</ControlLabel>
                    <FormControl type="date" name="dateOfBirth"
                        value={props.dateOfBirth}
                        onChange={props.handleInputChange}
                    />
                </div>
                <div>
                    <ControlLabel>Nationality</ControlLabel>
                    <FormControl type="text" name="nationality"
                        value={props.nationality}
                        onChange={props.handleInputChange} />
                </div>
            </div>

        </div>
    );
}

export const AddressComponent = (props) => {
    return (
        <div className="bottomPadding">

            <ControlLabel>Number and Street Name *</ControlLabel>
            <FormControl type="text"
                name="streetNumberName"
                value={props.streetNumberName}
                onChange={props.handleInputChange} />
            <div className="rowC">
                <div>
                    <ControlLabel>Unit Type</ControlLabel>
                    <FormControl componentClass="select" name="unitType" placeholder="select"
                        value={props.unitType} onChange={props.handleInputChange} >
                        <option value=""></option>
                        <option value="Apt">Apt</option>
                        <option value="Ste">Ste</option>
                        <option value="Flr">Flr</option>
                    </FormControl>
                </div>
                <div>
                    <ControlLabel>Unit Number</ControlLabel>
                    <FormControl type="text" name="unitNumber"
                        value={props.unitNumber}
                        onChange={props.handleInputChange} />
                </div>
            </div>
            <ControlLabel>City *</ControlLabel>
            <FormControl type="text" name="city"
                value={props.city} onChange={props.handleInputChange}                
            />

            <div className="rowC" >
                <div>
                    <ControlLabel>State</ControlLabel>
                    <FormControl name="state"
                        componentClass="select"
                        placeholder="select"
                        disabled={!(props.country == "USA" || props.country == "United States of America") }
                        value={props.state}
                        onChange={props.handleInputChange}>
                        <option></option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District Of Columbia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="OH">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WI">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                    </FormControl>
                </div>
                <div>
                    <ControlLabel>Zip Code</ControlLabel>
                    <FormControl type="text" name="zipCode"
                        disabled={!(props.country == "USA" || props.country == "United States of America")}
                        value={props.zipCode} onChange={props.handleInputChange} />
                </div>
            </div>
            <div className="rowC">
                <div>
                    <ControlLabel>Province</ControlLabel>
                    <FormControl type="text" name="province"
                        disabled={(props.country == "USA" || props.country == "United States of America")}
                        value={props.province} onChange={props.handleInputChange} />
                </div>
                <div>
                    <ControlLabel>Postal Code</ControlLabel>
                    <FormControl type="text" name="postalCode"
                        disabled={(props.country == "USA" || props.country == "United States of America")}
                        value={props.postalCode} onChange={props.handleInputChange} />
                </div>
            </div>
            <ControlLabel>Country *</ControlLabel>
            <FormControl type="text" name="country"
                value={props.country} onChange={props.handleInputChange} />

        </div>
    );

}



// WEBPACK FOOTER //
// ./src/common/FunctionComponents.js